import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@components/atoms";
import { Text } from "@components/atoms";
import type { ApiError } from "@/types";

interface ErrorMessageProps {
  error: ApiError;
  onRetry?: () => void;
}

/** Displays an error message with optional retry action. */
export function ErrorMessage({ error, onRetry }: ErrorMessageProps) {
  return (
    <div
      className="flex flex-col items-center gap-4 py-12 text-center"
      role="alert"
    >
      <AlertTriangle size={40} className="text-red-500" />
      <Text variant="h4" as="p" className="text-primary-100">
        {error.message || "Ha ocurrido un error inesperado"}
      </Text>
      {error.code && (
        <Text variant="body-sm" as="span" className="text-primary-100/60">
          Código: {error.code}
        </Text>
      )}
      {onRetry && (
        <Button
          variant="outline"
          onClick={onRetry}
          className="text-sm px-3 py-1.5"
        >
          <RefreshCw size={16} className="mr-2" />
          Reintentar
        </Button>
      )}
    </div>
  );
}
